export default __webpack_public_path__ + "static/media/avatar.e0be6b7c.png";